module.exports = __webpack_public_path__ + "img/R8801-IL.49f456b0.jpg";